const getCookie = name => {
  return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
}

export default getCookie
